import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=11b3605d&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=11b3605d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b3605d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b3605d')) {
      api.createRecord('11b3605d', component.options)
    } else {
      api.reload('11b3605d', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=11b3605d&scoped=true&", function () {
      api.rerender('11b3605d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OVdrpHunoy1Z/JS/comp/CookieBox.vue"
export default component.exports